import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, watch, nextTick, toRefs } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isShowPopover: {
      type: Boolean
    },
    triggerElement: {},
    elPosition: {
      default: ''
    },
    zIndex: {
      default: 3000
    }
  },
  emits: ["showMctPopover"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      isShowPopover,
      triggerElement,
      elPosition
    } = toRefs(props);
    const emits = __emit;
    const overflowX = ref(false);
    const overflowY = ref(false);
    const contentWrapper = ref();
    const position = async () => {
      await nextTick();
      const {
        left,
        top,
        height,
        width
      } =
      // @ts-ignore
      triggerElement.value.getBoundingClientRect();
      const {
        innerWidth,
        innerHeight,
        scrollX,
        scrollY
      } = window;
      const contentWrapperRect = contentWrapper.value.getBoundingClientRect();
      let newTop = top + height + 3 + scrollY;
      let newLeft = left + scrollX;
      if (elPosition.value === 'right') {
        newTop = top + scrollY;
        newLeft = left + width - 1;
      } else if (elPosition.value === 'bottom') {
        newLeft = left + scrollX - contentWrapperRect.width / 2 + 10;
      } else if (elPosition.value === 'top') {
        newTop = top - contentWrapperRect.height - 10;
        newLeft = left + scrollX - contentWrapperRect.width / 2 + 10;
      }
      overflowX.value = false;
      // Check if contentWrapper overflows the right edge of the window
      if (newLeft + contentWrapperRect.width > innerWidth + scrollX) {
        newLeft = left + 160 + scrollX - contentWrapperRect.width;
        if (elPosition.value === 'bottom') {
          newLeft = left + 60 + scrollX - contentWrapperRect.width;
        }
        overflowX.value = true;
      }
      overflowY.value = false;
      // Check if contentWrapper overflows the bottom edge of the window
      if (newTop + contentWrapperRect.height > innerHeight + scrollY) {
        newTop = top - contentWrapperRect.height + scrollY;
        overflowY.value = true;
      }
      // Apply the calculated position
      contentWrapper.value.style.top = `${Math.floor(newTop)}px`;
      contentWrapper.value.style.left = `${Math.floor(newLeft)}px`;
    };
    const openPopover = () => {
      emits('showMctPopover', true);
      document.addEventListener('click', listener);
    };
    const closePopover = () => {
      emits('showMctPopover', false);
      document.removeEventListener('click', listener);
    };
    const listener = event => {
      // do nothing when clicked (trigger) element is popover window
      if (contentWrapper.value && contentWrapper.value.contains(event.target) || contentWrapper.value === event.target) {
        return;
      }
      // do nothing when clicking clicked (trigger) element again
      if (
      // @ts-ignore
      triggerElement.value && triggerElement.value.contains(event.target) ||
      // @ts-ignore
      triggerElement.value === event.target) {
        return;
      }
      // close the popover window when clicking any other element
      closePopover();
    };
    watch([isShowPopover, triggerElement], () => {
      if (isShowPopover.value) {
        openPopover();
        position();
      }
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "mct-popover",
        style: _normalizeStyle({
          zIndex: _ctx.zIndex
        }),
        ref_key: "contentWrapper",
        ref: contentWrapper
      }, [_renderSlot(_ctx.$slots, "default", {
        overflowX: overflowX.value,
        overflowY: overflowY.value
      })], 4)), [[_vShow, _unref(isShowPopover)]]);
    };
  }
});